import { render, staticRenderFns } from "./WalletStatistics.vue?vue&type=template&id=0cec80be&scoped=true&"
import script from "./WalletStatistics.vue?vue&type=script&lang=js&"
export * from "./WalletStatistics.vue?vue&type=script&lang=js&"
import style0 from "./WalletStatistics.vue?vue&type=style&index=0&id=0cec80be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cec80be",
  null
  
)

export default component.exports